import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Logo } from "../../components/shared";
import { toast } from "sonner";

export default function VendorActivation() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, valid: false, business: "" });
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get(`/vendor/activation/validate?token=${encodeURIComponent(token)}`)
      .then((response) => setState({ loading: false, valid: true, business: response.data.business_name }))
      .catch(() => setState({ loading: false, valid: false, business: "" }));
  }, [token]);

  const activate = async () => {
    if (password.length < 8) return toast.error("Use at least 8 characters for your password");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/vendor/activation", { token, password });
      toast.success("Vendor account activated. Please sign in.");
      window.location.assign("/login");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not activate your account");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10">
      <section className="mx-auto max-w-md border border-slate-200 bg-white p-7 sm:p-9" data-testid="vendor-activation-page">
        <Logo />
        <p className="mt-8 text-xs font-semibold uppercase tracking-wide text-emerald-700">Vendor account activation</p>
        <h1 className="mt-2 font-display text-3xl font-bold">Create your portal password</h1>
        {state.loading ? <p className="mt-5 text-sm text-slate-500">Checking your secure activation link…</p> : !state.valid ? (
          <div className="mt-5 border border-rose-200 bg-rose-50 p-4 text-sm text-rose-900" data-testid="vendor-activation-invalid">
            This activation link is no longer available. Ask MySocietyMitra to issue a new invitation.
          </div>
        ) : (
          <div className="mt-6 space-y-4">
            <p className="text-sm text-slate-600" data-testid="vendor-activation-business">{state.business}</p>
            <div>
              <Label className="mb-1.5 block" htmlFor="vendor-activation-password">New password</Label>
              <Input data-testid="vendor-activation-password" id="vendor-activation-password" onChange={(event) => setPassword(event.target.value)} type="password" value={password} />
            </div>
            <div>
              <Label className="mb-1.5 block" htmlFor="vendor-activation-confirm">Confirm password</Label>
              <Input data-testid="vendor-activation-confirm" id="vendor-activation-confirm" onChange={(event) => setConfirm(event.target.value)} type="password" value={confirm} />
            </div>
            <Button className="w-full" data-testid="vendor-activation-submit" disabled={busy} onClick={activate} type="button">
              {busy ? "Activating…" : "Activate Vendor Portal"}
            </Button>
          </div>
        )}
        <Link className="mt-6 inline-block text-sm font-semibold text-emerald-800 hover:underline" data-testid="vendor-activation-login-link" to="/login">
          Back to sign in
        </Link>
      </section>
    </main>
  );
}